<template>
    <div>
        <h2 class="text-md-center">Hobbies</h2>
        <Hobby :hobby="'DnD'" :hobby-points="dnd"></Hobby>
    </div>
</template>

<script>
    import Hobby from "@/components/Hobby";

    export default {
        name: "Hobbies",
        components: {
            Hobby
        },
        data() {
            return {
                dnd: [
                    'Active DND player/dungeon master since 2010',
                    'Improves creativity, compassion, and disaster recovery through teamwork',
                    'Dungeon master (leader/fun coach) of usually 2 campaigns',
                    'Exploring Roll20\'s open Javascript API for open source contribution'
                ]
            }
        }
    }
</script>

<style scoped>

</style>
